//add patterns as you want
const console = window.console;
const patterns = {
  testLog: (payload) => {
    console.log(
      `%c       _                _              _               _       \n` +
        `%c      /\\ \\             /\\ \\           / /\\            /\\ \\     \n` +
        `%c      \\_\\ \\           /  \\ \\         / /  \\           \\_\\ \\    \n` +
        `%c      /\\__ \\         / /\\ \\ \\       / / /\\ \\__        /\\__ \\   \n` +
        `%c     / /_ \\ \\       / / /\\ \\_\\     / / /\\ \\___\\      / /_ \\ \\  \n` +
        `%c    / / /\\ \\ \\     / /_/_ \\/_/     \\ \\ \\ \\/___/     / / /\\ \\ \\ \n` +
        `%c   / / /  \\/_/    / /____/\\         \\ \\ \\          / / /  \\/_/ \n` +
        `%c  / / /          / /\\____\\/     _    \\ \\ \\        / / /        \n` +
        `%c / / /          / / /______    /_/\\__/ / /       / / /         \n` +
        `%c/_/ /          / / /_______\\   \\ \\/___/ /       /_/ /          \n` +
        `%c\\_\\/           \\/__________/    \\_____\\/        \\_\\/           \n` +
        '\n' +
        '%c#############################################################\n' +
        '\n',
      'color:#fc6203',
      'color:#fc8803',
      'color:#fcba03',
      'color:#fcf003',
      'color:#d3fc03',
      'color:#b1fc03',
      'color:#d3fc03',
      'color:#fcf003',
      'color:#fcba03',
      'color:#fc8803',
      'color:#fc6203',
      'color:#00ffbb',
      ...payload,
    );
  },
  errorLog: (payload) => {
    console.log(
      `%c         _               _               _               _                _      \n` +
        `%c        /\\ \\            /\\ \\            /\\ \\            /\\ \\             /\\ \\    \n` +
        `%c       /  \\ \\          /  \\ \\          /  \\ \\          /  \\ \\           /  \\ \\   \n` +
        `%c      / /\\ \\ \\        / /\\ \\ \\        / /\\ \\ \\        / /\\ \\ \\         / /\\ \\ \\  \n` +
        `%c     / / /\\ \\_\\      / / /\\ \\_\\      / / /\\ \\_\\      / / /\\ \\ \\       / / /\\ \\_\\ \n` +
        `%c    / /_/_ \\/_/     / / /_/ / /     / / /_/ / /     / / /  \\ \\_\\     / / /_/ / / \n` +
        `%c   / /____/\\       / / /__\\/ /     / / /__\\/ /     / / /   / / /    / / /__\\/ /  \n` +
        `%c  / /\\____\\/      / / /_____/     / / /_____/     / / /   / / /    / / /_____/   \n` +
        `%c / / /______     / / /\\ \\ \\      / / /\\ \\ \\      / / /___/ / /    / / /\\ \\ \\     \n` +
        `%c/ / /_______\\   / / /  \\ \\ \\    / / /  \\ \\ \\    / / /____\\/ /    / / /  \\ \\ \\    \n` +
        `%c\\/__________/   \\/_/    \\_\\/    \\/_/    \\_\\/    \\/_________/     \\/_/    \\_\\/    \n` +
        '\n' +
        '%c################################################################################\n' +
        '\n',
      'color:#fc6203',
      'color:#fc8803',
      'color:#fcba03',
      'color:#fcf003',
      'color:#d3fc03',
      'color:#b1fc03',
      'color:#d3fc03',
      'color:#fcf003',
      'color:#fcba03',
      'color:#fc8803',
      'color:#fc6203',
      'color:#f54248',
      ...payload,
    );
  },
};

export const { testLog, errorLog } = patterns;
